import React, { useContext } from 'react'
import GlobalContext from '../../../store/global-context'
import { config } from '../../../config'
import './WelcomeMessage.css'

function WelcomeMessage() {
   const globalCtx = useContext(GlobalContext);

   const newSeasonBeginDate = globalCtx.layoutModel?.newSeasonBeginDate;
   const oldSeasonEndDate = globalCtx.layoutModel?.oldSeasonEndDate;

   function getNewSeason() {
      let x = newSeasonBeginDate;
      let year = x.slice(-4);
      return year + '-' + (year-(-1));
   }

   function getOldSeason() {
      let x = newSeasonBeginDate;
      let year = x.slice(-4);
      return (year-1) + '-' + year;
   }

   function getBeginDay() {
      let x = newSeasonBeginDate;
      let y = x.split(',');
      let z = y[0].split(' ');
      let month = z[0];
      let day = z[1];
      let s = 'th';
      if (day === '1' || day === '21' || day === '31') {
         s = 'st';
      } else if (day === '2' || day === '22') {
         s = 'nd';
      } else if (day === '3' || day === '23') {
         s = 'rd';
      }
      return month + ' ' + day + s;
   }

   const oldSeason = getOldSeason();
   const newSeason = getNewSeason();
   const beginDay = getBeginDay();

   return (
      <>
      <div className="accordion mb-3" id="accordionParent">
         <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                     <span className='filter-title position-relative'>
                        Messages
                     </span>
               </button>
            </h2>
            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionParent">
               <div className="accordion-body">
                  <span className="heading">ATTENTION:</span>
                  <br />
                  Supply orders for the <span className="emphasized">{newSeason} season</span> will begin 
                  on <span className="emphasized">{newSeasonBeginDate}</span>.{' '}
                  <u>All</u> orders for supplies placed after <span className="emphasized">{beginDay}</span> will be 
                  for the <span className="emphasized">{newSeason} season</span>. The online ordering system 
                  will close on <span className="emphasized">{oldSeasonEndDate}</span> and will be unavailable 
                  until <span className="emphasized">{beginDay}</span>. Associations that 
                  need to place orders for supplies to complete 
                  the <span className="emphasized">{oldSeason} season</span> will need to 
                  email <a href="mailto:supplyorders@bowl.com" target="_blank>supplyorders@bowl.com">supplyorders@bowl.com</a>
                  <br />
                  <br />
                  <span className="heading">NOTICE:</span>
                  <br />
                  Please note that if you have a change that needs to be made to your supply order, please email{' '} 
                  <a href="mailto:supplyorders@bowl.com" target="_blank>supplyorders@bowl.com">supplyorders@bowl.com</a>{' '}
                  <span className="emphasized">BEFORE</span> hitting submit.{' '}
                  <span className="emphasized">DO NOT</span> hit submit if you would like changes made to your order.
                  <br />
                  <br />  
                  Also, please be sure to verify your supply orders as soon as they are received.  While we understand 
                  that mistakes happen, we need to make sure that the orders are correct when they
                  are received so that we can correct any inventory issues immediately and send the correct items right out.  
                  Please contact us within <span className="emphasized">30 days of receiving your shipment</span> with any errors 
                  or we will assume your order is correct and was received in full.<br />
               </div>
            </div>
         </div>
      </div>
      </>
    );
}

export default WelcomeMessage